import React, { useRef, useEffect, useState } from 'react';
import { zcTexts } from '../contexts/LangZC';
// 이미지 import
import ProductZCFunction, {getFeatures} from './ProductZC-function';
import ProductZCSpecial from './ProductZC-special';
import ProductZCOutline from './ProductZC-outline';
import ProductZCUsecase from './ProductZC-usecase';
import ProductZCCertification from './ProductZC-certification';

function ProductZC({ lang = 'ko' }) {
  const sectionRef = useRef(null);
  const stickyRef = useRef(null);
  const certRef = useRef(null);
  const [slideIdx, setSlideIdx] = useState(0);
  const [isHover, setIsHover] = useState(false);
  const [certVisible, setCertVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // 애니메이션 상태 추가
  const [featureVisible, setFeatureVisible] = useState(false);
  const featureSectionRef = useRef(null);

  const features = getFeatures(lang);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    setTimeout(() => setFeatureVisible(true), 500); // 페이지 진입 후 0.2초 뒤 실행
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const totalHeight = rect.height - windowHeight;
      if (rect.top <= 0 && Math.abs(rect.top) <= totalHeight) {
        const percent = Math.abs(rect.top) / totalHeight;
        setSlideIdx(Math.round(percent * (features.length - 1)));
      } else if (rect.top > 0) {
        setSlideIdx(0);
      } else if (Math.abs(rect.top) > totalHeight) {
        setSlideIdx(features.length - 1);
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 좌우 키/휠 이벤트 처리
  useEffect(() => {
    if (!isHover) return;

    const handleKeyDown = (e) => {
      if (e.key === 'ArrowRight') {
        setSlideIdx(idx => Math.min(idx + 1, features.length - 1));
      } else if (e.key === 'ArrowLeft') {
        setSlideIdx(idx => Math.max(idx - 1, 0));
      }
    };
    const handleWheel = (e) => {
      if (slideIdx === 0 && e.deltaY < 0) {
        return;
      }
      if (slideIdx === features.length - 1 && e.deltaY > 0) {
        return;
      }
      e.preventDefault();
      if (e.deltaY > 0) {
        setSlideIdx(idx => Math.min(idx + 1, features.length - 1));
      } else if (e.deltaY < 0) {
        setSlideIdx(idx => Math.max(idx - 1, 0));
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('wheel', handleWheel, { passive: false });
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('wheel', handleWheel);
    };
  }, [isHover, slideIdx, features.length]);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setCertVisible(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (certRef.current) observer.observe(certRef.current);
    return () => observer.disconnect();
  }, []);

  // IntersectionObserver로 화면에 보이면 애니메이션 트리거
  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setFeatureVisible(entry.isIntersecting),
      { threshold: 0 } // 한 픽셀만 보여도 바로 실행
    );
    if (featureSectionRef.current) observer.observe(featureSectionRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    console.log('featureVisible:', featureVisible);
  }, [featureVisible]);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#29225C',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: '100vw',
        overflowX: 'hidden',
        padding: isMobile ? '0 20px' : '0'
      }}
    >
      <h1 style={{
        color: '#fff',
        fontSize: isMobile ? '1.8rem' : '2.5rem',
        fontWeight: 700,
        letterSpacing: '-1px',
        margin: 0,
        marginTop: isMobile ? 40 : 60,
        marginBottom: isMobile ? 30 : 40,
        textAlign: 'center',
        lineHeight: isMobile ? 1.3 : 1.2,
        padding: isMobile ? '0 10px' : '0'
      }}>
        {!isMobile && <><br /><br /></>}{zcTexts.title[lang]}
        <br /><span style={{ color: '#ffb300' }}>{zcTexts.subtitle[lang]}</span>
      </h1>

      {/* ZONECENTRAL 개요 섹션 */}
      <ProductZCOutline lang={lang} isMobile={isMobile} />

      {/* ZONECENTRAL 특징 섹션 */}
      <ProductZCSpecial
        featureVisible={featureVisible}
        featureSectionRef={featureSectionRef}
        lang={lang}
        isMobile={isMobile}
      />

      {/* ZONECENTRAL 주요기능 섹션 */}
      <ProductZCFunction
        sectionRef={sectionRef}
        stickyRef={stickyRef}
        isHover={isHover}
        setIsHover={setIsHover}
        slideIdx={slideIdx}
        lang={lang}
        isMobile={isMobile}
      />
      <ProductZCUsecase lang={lang} isMobile={isMobile} />

      {/* 인증 섹션 */}
      <ProductZCCertification
        certRef={certRef}
        certVisible={certVisible}
        lang={lang}
        isMobile={isMobile}
      />
    </div>
  );
}

export default ProductZC;

